import 'date-fns'
import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import ptBRLocale from 'date-fns/locale/pt-BR'

export const SelecionarDataFutura = (props) => {
  const {
    dataBD,
    callback,
    label,
    required,
    // minDate,
    name,
    disabled,
    withoutTime,
    shrink,
    md,
    sm,
    lg,
    xs,
    maxDate,
    minutesStep,
  } = props

  const [selectedDate, setSelectedDate] = useState(dataBD)

  const handleDateChange = (date) => {
    if (withoutTime && date) date.setHours(0, 0, 0, 0)

    setSelectedDate(date)
    callback(date)
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
      <Grid md={md} sm={sm} lg={lg} xs={xs}>
        <KeyboardDateTimePicker
          disabled={disabled}
          variant="inline"
          inputVariant="outlined"
          ampm={false}
          format={withoutTime ? 'dd/MM/yyyy' : 'dd/MM/yyyy  HH:mm'}
          id={label}
          label={label}
          value={dataBD || selectedDate}
          onChange={handleDateChange}
          minDate={new Date()}
          maxDate={maxDate? new Date(Date.now() + maxDate*24*60*60*1000) : null}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          InputLabelProps={{
            shrink,
            style: shrink ? { fontSize: '16px' } : null,
          }}
          required={required === true}
          name={name}
          minutesStep={minutesStep || 1}
          fullWidth
        />
      </Grid>
    </MuiPickersUtilsProvider>
  )
}
